import React, { useState } from 'react';
import { Modal } from '@roo/roo';
import styled from 'styled-components';

const Root = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #222222;
  line-height: 20px;
`;

export const JudgeAgreement = () => (
  <Root className="text">
    为营造健康的学术氛围和良好的学术生态，维护评审工作的公正性，本人在此郑重承诺：在参与美团青山科技基金专家评审活动的全过程中，遵守相关法律法规与基金有关管理办法，严守科研诚信要求，恪守职业规范和科学道德；遵守评审规则和工作纪律，独立、客观、公正开展工作，为项目评审提供负责任、高质量的评审意见；在评审前和评审期间如遇到请托电话、信息等影响公正性的不良行为，将如实向评审组织方报告。本人将杜绝以下行为：
    <br />
    （一）违反回避的相关要求，隐瞒利益冲突；
    <br />
    （二）擅自与被评审利益相关方联系、串通；
    <br />
    （三）违反公平公正原则，有参与不正当竞争、恶意串通等违规行为，采用不正当方式引导、影响评审结果；
    <br />
    （四）索取、收受评审利益相关方的财物或其他利益，违反规定到被评审单位报销任何费用；
    <br />
    （五）利用评审专家的身份或影响力参与有偿商业活动；
    <br />
    （六）擅自委托他人代替自己开展评审工作；
    <br />
    （七）违反保密规定，泄露与评审有关的技术秘密和商业秘密等；
    <br />
    （八）违反评审规定，透露评审过程中的专家名单、专家意见或评审结果等；
    <br />
    （九）剽窃评审材料内容，或未经许可对相关材料进行复制，泄露，引用或留存等；
    <br />
    （十）其他违反评审规定，相关法律法规的行为。
    <br />
    如有违反，本人愿接受评审组织方和有关部门做出的各项处理决定，包括但不限于取消评审专家资格等。
  </Root>
);

export const Agreement = React.forwardRef((props, ref) => {
  const [visible, setVisible] = React.useState(false);
  React.useImperativeHandle(ref, () => ({
    open() {
      setVisible(true);
    },
  }));

  if (props.type === 1) {
    return (
      <Modal
        title="《青山科技奖申报承诺书》"
        visible={visible}
        style={{ width: 800 }}
        onCancel={() => setVisible(false)}
        onConfirm={() => {
          setVisible(false);
          props.onConfirm?.();
        }}
        confirmText="同意，继续申报"
        showCancelButton={false}
      >
        <Root className="text">
          作为“青山科技奖”申报人，本人在此郑重承诺，坚守学术道德，秉持科学精神，恪守科研诚信。本人申报提交的材料和相关内容合法、真实、可靠，不存在以下行为：
          <br />
          （一）虚构或夸大个人信息、教育经历、科研与学术工作经历、个人主要学术成就、所参与项目、个人实际获得奖励等申报基本信息；
          <br />
          （二）提交的学术成果及未来工作规划涉嫌抄袭、剽窃他人科研成果，伪造、篡改研究数据、研究结论，或者侵犯他人知识产权；
          <br />
          （三）盗用、冒用他人学术成果，虚构、夸大学术成果中的本人作用和主要贡献，或者与他人存在知识产权权属纠纷；
          <br />
          （四）提交的学术成果涉嫌侵犯商业秘密、数据隐私或违反其他有关法律法规规定；
          <br />
          （五）虚构推荐人及其意见；
          <br />
          （六）研究内容不符合社会公德和科学伦理；
          <br />
          （七）所提交的材料和相关内容涉及国家秘密。
          <br />
          本人在“青山科技奖”申请和评审全过程中，不存在以下行为：
          <br />
          （一）以任何形式探听未公开的评审专家名单及其他评审过程中的保密信息；
          <br />
          （二）本人或委托他人通过各种方式及各种途径联系评审专家影响评审结果；
          <br />
          （三）其他违反《“青山科技奖”章程》及相关规定的行为。
          <br />
          如违背上述承诺，本人愿接受相关处理决定，包括但不限于撤销本年度的获奖资格，退还已获得的全部奖励金额，永久取消“青山科技奖”申请资格。若给“青山科技奖”相关单位或机构造成任何损失，本人愿意承担相关法律责任。
        </Root>
      </Modal>
    );
  }

  if (props.type === 2) {
    return (
      <Modal
        title="《科创中国-美团青山环保科技创新示范项目申报承诺书》"
        visible={visible}
        style={{ width: 800 }}
        onCancel={() => setVisible(false)}
        onConfirm={() => {
          setVisible(false);
          props.onConfirm?.();
        }}
        confirmText="同意，继续申报"
        showCancelButton={false}
      >
        <Root className="text">
          作为“科创中国-美团青山环保科技创新示范项目”申报机构，本机构郑重承诺，申报提交的材料和相关内容合法、真实、可靠，不存在以下行为：
          <br />
          （一）虚构或隐瞒机构基本信息、申报人信息、运营资质信息，夸大机构财务信息、专利和科技成果等关键信息；
          {' '}
          <br />
          （二）提交的项目申报相关材料涉嫌侵犯他人知识产权；
          {' '}
          <br />
          （三）提交的项目申报材料中虚构、夸大或隐瞒项目技术可行性、合作方资源、项目预算、现有投入、社会影响力和环境效益等关键信息；
          {' '}
          <br />
          （四）提交的项目申报材料涉嫌侵犯商业秘密、数据隐私或违反有关法律法规规定；
          {' '}
          <br />
          （五）提交的项目申报材料内容不符合社会公德和商业、科学伦理；
          {' '}
          <br />
          （六）提交的专利、科技成果信息涉嫌抄袭、剽窃他人科研成果及创意，或者与他人存在知识产权权属纠纷；
          {' '}
          <br />
          （七）所提交的材料和相关内容涉及国家秘密。
          {' '}
          <br />
          本机构在“科创中国-美团青山环保科技创新示范项目”申请和评审全过程中，不存在以下行为：
          {' '}
          <br />
          （一）以任何形式探听未公开的评审专家名单及其他评审过程中的保密信息；
          {' '}
          <br />
          （二）本机构成员或委托外部人员通过各种方式及各种途径联系评审专家影响评审结果；
          {' '}
          <br />
          （三）其他违反《“科创中国-美团青山环保科技创新示范项目”实施办法》及相关规定的行为。
          {' '}
          <br />
          如违背上述承诺，本机构愿接受相关处理决定，包括但不限于撤销本年度的项目拨款，退还已获得的全部资助金额，永久取消“科创中国-美团青山环保科技创新示范项目”申请资格。若给“示范项目”相关机构或机构造成任何损失，本机构愿意承担相关法律责任。
        </Root>
      </Modal>
    );
  }
});
